import { ParseDataMobile } from "../../util/parse-data-mobile";
import { ParseCurrencyMobile } from "../../util/parse-currency-mobile";
import { PersonalData } from "../../../../../../personal-data/model/personal-data";
import { MaritalStatus } from "../../../../../../marital-status/model/marital-status-data";
import { ProfessionalData } from "../../../../../../professional-data/model/professional-data";
import { IncomeEquityData } from "../../../../../../income-wealth/model/income-equity-data";
import { Address } from "../../../../../../address/model/address";
import { ParseContaIonData } from "../../util/parsed-conta-ion-data";
import { RegistratioJourney } from "../../../../../../shared/model/registration-journey";

export class ContaIonDataParse {
  public static parseFromMobileData(data: any): RegistratioJourney {
    let parsedData: RegistratioJourney = data;

    if (!parsedData.data.personalData) {
      parsedData.data.personalData = new PersonalData();
    }
    if (!parsedData.data.maritalStatus) {
      parsedData.data.maritalStatus = new MaritalStatus();
    }
    if (!parsedData.data.professionalData) {
      parsedData.data.professionalData = new ProfessionalData();
    }
    if (!parsedData.data.incomeEquity) {
      parsedData.data.incomeEquity = new IncomeEquityData();
    }
    if (!parsedData.data.address) {
      parsedData.data.address = new Address();
    }

    parsedData = ParseContaIonData.parse(parsedData);

    parsedData.data.personalData.issueDate = ParseDataMobile.parse(
      parsedData.data?.personalData?.issueDate
    );
    parsedData.data.personalData.dateOfBirth = ParseDataMobile.parse(
      parsedData.data?.personalData?.dateOfBirth
    );

    parsedData.data.incomeEquity.income = ParseCurrencyMobile.parse(
      parsedData.data?.incomeEquity?.income
    );
    parsedData.data.incomeEquity.patrimony = ParseCurrencyMobile.parse(
      parsedData.data?.incomeEquity?.patrimony
    );

    return parsedData;
  }
}
